<template>
  <div class="relative">
    <number-input
      v-model="insideValue"
      class="pr-8"
      :disabled="disabled"
      :min="0"
      :max="100"
      :step="1"
      :decimals="decimals"
    />
    <span class="pointer-events-none absolute top-1/2 right-3 -translate-y-1/2 text-sm text-muted-foreground">%</span>
  </div>
</template>

<script>
import NumberInput from '@/ui/components/NumberInput.vue';

export default {
  name: 'PercentageInput',
  components: {
    NumberInput,
  },
  props: {
    modelValue: {
      type: [ Number, String, null ],
      required: false,
      default: () => null,
    },
    decimals: {
      type: Number,
      required: false,
      default: () => 2,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    insideValue: '',
  }),
  watch: {
    insideValue() {
      this.$emit('update:modelValue', this.insideValue);
    },
    modelValue: {
      immediate: true,
      handler() {
        this.insideValue = this.modelValue;
      },
    },
  },
};
</script>
